import type { HelpFile } from '../../types/help'
import { ApprovalPolicyFormTestIds } from '../../../testids/ApprovalPolicyFormTestIds'

export const approvalPolicyFormHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalPolicyFormTestIds.btnAddCondition]:
      'Fügt eine neue Bedingung hinzu, die festlegt, wann diese Genehmigungsrichtlinie greift.',
    [ApprovalPolicyFormTestIds.btnAddStep]:
      'Fügt einen neuen Genehmigungsschritt hinzu. Jeder Schritt definiert, wer in dieser Stufe genehmigen muss.',
    [ApprovalPolicyFormTestIds.btnCancel]: null,
    [ApprovalPolicyFormTestIds.btnSubmit]: null,
    [ApprovalPolicyFormTestIds.cardTitleConditions]:
      'Bedingungen, die alle erfüllt sein müssen, damit diese Richtlinie greift — je eine pro Filterkriterium.',
    [ApprovalPolicyFormTestIds.cardTitleSteps]:
      'Geordnete Genehmigerkette — jeder Schritt läuft nacheinander und muss abgeschlossen sein, bevor der nächste beginnt.',
    [ApprovalPolicyFormTestIds.inputName]: null,
    [ApprovalPolicyFormTestIds.inputDescription]: null,
    [ApprovalPolicyFormTestIds.inputPriority]:
      'Niedrigerer Wert gewinnt, wenn mehrere Richtlinien auf denselben Antrag zutreffen.',
    [ApprovalPolicyFormTestIds.policyTypeReadonly]:
      'Nach der Erstellung unveränderlich — bestimmt, welche Antragstypen diese Richtlinie treffen kann.',
    [ApprovalPolicyFormTestIds.selectApprovalStrategy]:
      'Wie Entscheidungen innerhalb dieses Schritts zusammengeführt werden — einzelner Genehmiger, alle erforderlich oder ein beliebiger.',
    [ApprovalPolicyFormTestIds.selectConditionField]:
      'Antragsattribut, das diese Bedingung auswertet — z. B. Zugriffsprofil oder Zielsystem.',
    [ApprovalPolicyFormTestIds.selectConditionOperator]:
      'Vergleichsoperator für das Feld — gleich, in, beginnt mit usw.',
    [ApprovalPolicyFormTestIds.selectPolicyType]:
      'Antragstyp, den diese Richtlinie treffen kann — bestimmt, welche Bedingungsfelder verfügbar sind.',
    [ApprovalPolicyFormTestIds.selectResolverType]:
      'Wie die Genehmiger dieses Schritts ermittelt werden — feste Identität, Rolle, Vorgesetzter des Antragstellers usw.',
  },
}
